import {
  ALL_TASKS_LINKED_ITEM_ID,
  EntityLinks,
  Goal,
  IconFormNames,
  ID,
  LifeArea,
} from '@griply/types';

import { getLinkedItemColor } from './get-linked-item-color';

export type CalendarSyncTarget = {
  name: string | null;
  iconName: IconFormNames | null;
  color: string | null;
  isGoal: boolean;
  isAllTasks: boolean;
};

export type ResolveCalendarSyncTargetOptions = {
  goals: Goal[];
  lifeAreas: LifeArea[];
  links: EntityLinks;
};

const UNRESOLVED: CalendarSyncTarget = {
  name: null,
  iconName: null,
  color: null,
  isGoal: false,
  isAllTasks: false,
};

// Resolved against the *unfiltered* goals/life areas so a sync targeting an archived or
// completed item still renders its name — the pickers' own lists exclude those.
export const resolveCalendarSyncTarget = (
  linkedItemId: ID | null,
  { goals, lifeAreas, links }: ResolveCalendarSyncTargetOptions,
): CalendarSyncTarget => {
  if (linkedItemId === ALL_TASKS_LINKED_ITEM_ID) {
    return { ...UNRESOLVED, isAllTasks: true };
  }

  if (!linkedItemId) {
    return UNRESOLVED;
  }

  const goal = goals.find(({ id }) => id === linkedItemId);
  if (goal) {
    return {
      name: goal.name,
      iconName: goal.iconName ?? null,
      color: getLinkedItemColor(goal.id, { goals, lifeAreas, links }),
      isGoal: true,
      isAllTasks: false,
    };
  }

  const lifeArea = lifeAreas.find(({ id }) => id === linkedItemId);
  if (!lifeArea) {
    return UNRESOLVED;
  }

  return {
    name: lifeArea.name,
    iconName: lifeArea.iconName ?? null,
    color: lifeArea.color ?? null,
    isGoal: false,
    isAllTasks: false,
  };
};
